import { actionCreatorFactory } from "typescript-fsa";

import { Datetime } from "@tsp-core/datetime/types";

import { PartyUuid } from "@tsp-domains/parties/types";
import { PropertyUuid } from "@tsp-domains/projects-portfolio/types";
import { WorkItemEntityType } from "@tsp-domains/work-items/enums";

import { SupplierActualWorkType } from "../types";

const actionCreator = actionCreatorFactory("SUPPLIER_WORK_TYPES");

export type LoadSupplierActualWorkTypesActionParams = {
  momentAt: Datetime;
  propertyUuid: PropertyUuid;
  supplierUuids: Array<PartyUuid>;
  entityType: WorkItemEntityType;
  isActiveContracts: boolean | null;
};

export const loadSupplierActualWorkTypesAction = actionCreator.async<
  LoadSupplierActualWorkTypesActionParams,
  Array<SupplierActualWorkType>,
  string
>("LOAD");

export const resetSupplierActualWorkTypesAction = actionCreator("RESET");
